import { createFileRoute } from "@tanstack/react-router";
import ArticlePoolResurfacingVsRemodeling from "@/pages/ArticlePoolResurfacingVsRemodeling";
import { buildHead } from "@/lib/seo";
import { FEATURED_IMAGE_BEFORE_AFTER } from "@/data/blogData";
import { FAQS_POOL_RESURFACING_VS_REMODELING } from "@/data/poolResurfacingVsRemodelingData";

const PATH = "/blog/pool-resurfacing-vs-pool-remodeling";
const CANONICAL = `https://precisionpaverspools.com${PATH}`;

export const Route = createFileRoute(
  "/blog/pool-resurfacing-vs-pool-remodeling",
)({
  head: () =>
    buildHead({
      title: "Pool Resurfacing vs. Remodeling: Which Do You Need?",
      description:
        "Learn the difference between pool resurfacing and remodeling, what each project can include, and how to choose the right scope for your South Florida pool.",
      path: PATH,
      ogType: "article",
      ogImage: FEATURED_IMAGE_BEFORE_AFTER,
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline:
            "Pool Resurfacing vs. Pool Remodeling: Which Does Your Pool Need?",
          description:
            "Learn the difference between pool resurfacing and remodeling, what each project can include, and how to choose the right scope for your South Florida pool.",
          image: FEATURED_IMAGE_BEFORE_AFTER,
          datePublished: "2026-09-28",
          dateModified: "2026-09-28",
          author: {
            "@type": "Organization",
            name: "Precision Pavers & Pool Design",
          },
          publisher: {
            "@type": "Organization",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": CANONICAL,
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blog",
              item: "https://precisionpaverspools.com/blog",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Pool Resurfacing vs. Pool Remodeling",
              item: CANONICAL,
            },
          ],
        },
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS_POOL_RESURFACING_VS_REMODELING.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.answer,
            },
          })),
        },
      ],
    }),
  component: ArticlePoolResurfacingVsRemodeling,
});
